import { productsCategories, productsSlugs } from 'constants/products';

import hairMaskPicture from '../images/checkout_mask.png';
import hairMaskBgPicture from '../images/productPages/mask_carousel_1.jpg';
import hairMaskBgLabelledPicture from '../images/productPages/mask_carousel_2.jpg';

import shampooPicture from '../images/checkout_shampoo.png';
import shampooPictureWithCap from '../images/checkout_shampoo-cap.png';
import shampooBgPicture from '../images/productPages/shampoo_carousel_1.jpg';
import shampooBgLabelledPicture from '../images/productPages/shampoo_carousel_2.jpg';

import conditionerPicture from '../images/checkout_conditioner.png';
import conditionerPictureWithCap from '../images/checkout_conditioner-cap.png';
import conditionerBgPicture from '../images/productPages/conditioner_carousel_1.jpg';
import conditionerBgLabelledPicture from '../images/productPages/conditioner_carousel_2.jpg';

import oilPicture from '../images/checkout_hairoil.png';
import oilBgPicture from '../images/productPages/oil_carousel_1.jpg';
import oilBgLabelledPicture from '../images/productPages/oil_carousel_2.jpg';

import dryShampooPicture from '../images/checkout_dryshampoo.png';
import dryShampooBgPicture from '../images/productPages/dryshampoo_carousel_1.jpg';
import dryShampooBgLabelledPicture from '../images/productPages/dryshampoo_carousel_2.jpg';

import curlCreamPicture from '../images/checkout_curlcream.png';
import curlCreamPictureWithCap from '../images/checkout_curlcream-cap.png';
import curlCreamBgPicture from '../images/productPages/curlcream_carousel_1.jpg';
import curlCreamBgLabelledPicture from '../images/productPages/curlcream_carousel_2.jpg';

import leaveinPicture from '../images/checkout_leavein.png';
import leaveinPictureWithCap from '../images/checkout_leavein-cap.png';
import leaveinBgPicture from '../images/productPages/leavein_carousel_1.jpg';
import leaveinBgLabelledPicture from '../images/productPages/leavein_carousel_2.jpg';

import scalpMaskPicture from '../images/checkout_mask.png';
import scalpMaskBgPicture from '../images/productPages/scalpmask_carousel_1.jpg';
import scalpMaskBgLabelledPicture from '../images/productPages/scalpmask_carousel_2.jpg';

import shoPicture from '../images/checkout_sho.png';
import shoBgPicture from '../images/productPages/sho_carousel_1.jpg';
import shoBgLabelledPicture from '../images/productPages/sho_carousel_2.jpg';

import supplementsPicture from '../images/checkout_supplements.png';
/* Good to know: numbers directly on assets name is kinda brittle when a PM ask you to change images orders.
 That's why we don't go this road here. */
import supplementsBgPicture from '../images/productPages/supplements_carousel_jars_dark_bg.jpg';
import supplementsBgLabelledPicture from '../images/productPages/supplements_carousel_jars_light_bg.jpg';

import supplementsPouchPicture from '../images/checkout_supplements_pouches.png';

export const hair_mask = {
  capacity: '8.5 fl oz',
  cat: 'core',
  description:
    'A highly concentrated pre-wash treatment that restores moisture and smoothness to hair lengths and ends.',
  label: 'Pre-Shampoo Hair Mask',
  picture: hairMaskPicture,
  bgPicture: hairMaskBgPicture,
  bgLabelledPicture: hairMaskBgLabelledPicture,
  price: 42,
  productPageUrl: '/products/custom-hair-mask',
  slug: productsSlugs.HAIR_MASK,
  tag: 'Hydrate & Repair',
  type: productsCategories.FORMULA,
  usage: 'Approximately 8-10 weeks use.',
  usageB: '2x a week',
};

export const shampoo = {
  capacity: '8.5 fl oz',
  cat: 'core',
  description:
    'A gentle, sulfate-free cleanser that does everything from rebalancing your roots to adding light hydration.',
  label: 'Shampoo',
  picture: shampooPicture,
  pictureWithCap: shampooPictureWithCap,
  bgPicture: shampooBgPicture,
  bgLabelledPicture: shampooBgLabelledPicture,
  productPageUrl: '/products/custom-shampoo',
  price: 28,
  slug: productsSlugs.SHAMPOO,
  tag: 'Cleanse',
  type: productsCategories.FORMULA,
  usage: 'Approximately 8-10 weeks use.',
  usageB: 'Daily',
};

export const conditioner = {
  capacity: '8.5 fl oz',
  cat: 'core',
  description:
    'A nourishing moisturizer that will meet all of your hair goals and restore your strands without ever weighing them down.',
  label: 'Conditioner',
  picture: conditionerPicture,
  pictureWithCap: conditionerPictureWithCap,
  bgPicture: conditionerBgPicture,
  bgLabelledPicture: conditionerBgLabelledPicture,
  productPageUrl: '/products/custom-conditioner',
  price: 28,
  slug: productsSlugs.CONDITIONER,
  tag: 'Hydrate',
  type: productsCategories.FORMULA,
  usage: 'Approximately 8-10 weeks use.',
  usageB: 'Daily',
};

export const leavein = {
  capacity: '1.7 fl oz',
  cat: 'leavein',
  description:
    'Used as a treatment before washing or as a finishing product to style, this premium oil protects strands and smooths away frizz.',
  isNew: false,
  label: 'Hair Oil',
  picture: oilPicture,
  bgPicture: oilBgPicture,
  bgLabelledPicture: oilBgLabelledPicture,
  price: 48,
  productPageUrl: '/products/custom-hair-oil',
  slug: productsSlugs.OIL,
  tag: 'Treat & Style',
  cardTag: 'Award winning',
  type: productsCategories.FORMULA,
  usageB: 'As needed',
};

export const dry_shampoo = {
  capacity: '1.4 oz',
  description:
    'A translucent, powder dry shampoo that refreshes the roots and extends hairstyles, all while caring for your scalp needs.',
  isNew: false,
  label: 'Dry Shampoo',
  picture: dryShampooPicture,
  bgPicture: dryShampooBgPicture,
  bgLabelledPicture: dryShampooBgLabelledPicture,
  price: 26,
  productPageUrl: '/products/custom-dry-shampoo',
  slug: productsSlugs.DRY_SHAMPOO,
  tag: 'Cleanse & Refresh',
  type: productsCategories.FORMULA,
};

export const curl_cream = {
  capacity: '5.1 fl oz',
  description:
    'Used as a styler or for touch-ups, this cream defines your natural texture—from waves to curls and coils—while keeping strands hydrated and frizz-free.',
  isNew: false,
  label: 'Curl Cream',
  picture: curlCreamPicture,
  pictureWithCap: curlCreamPictureWithCap,
  bgPicture: curlCreamBgPicture,
  bgLabelledPicture: curlCreamBgLabelledPicture,
  price: 26,
  productPageUrl: '/products/custom-curl-cream',
  slug: productsSlugs.CURL_CREAM,
  tag: 'Define & De-frizz',
  type: productsCategories.FORMULA,
};

export const leavein_conditioner = {
  capacity: '5.1 fl oz',
  description:
    'This hydrating leave-in mist detangles and smooths flyaways, leaving strands soft, polished, and manageable.',
  isNew: false,
  label: 'Leave-In Conditioner',
  picture: leaveinPicture,
  pictureWithCap: leaveinPictureWithCap,
  bgPicture: leaveinBgPicture,
  bgLabelledPicture: leaveinBgLabelledPicture,
  price: 26,
  productPageUrl: '/products/custom-leave-in-conditioner',
  slug: productsSlugs.LEAVEIN_CONDITIONER,
  tag: 'Hydrate & Detangle',
  type: productsCategories.FORMULA,
};

export const scalp_mask = {
  capacity: '8.5 fl oz',
  description:
    'An intensive pre-wash treatment that helps restore balance to your scalp, whether you need soothing repair or a gentle detox.',
  label: 'Pre-Shampoo Scalp Mask',
  picture: scalpMaskPicture,
  bgPicture: scalpMaskBgPicture,
  bgLabelledPicture: scalpMaskBgLabelledPicture,
  price: 42,
  productPageUrl: '/products/custom-scalp-mask',
  slug: productsSlugs.SCALP_MASK,
  tag: 'Soothe & Balance',
  cardTag: 'New arrival',
  type: productsCategories.FORMULA,
};

export const shimmer_hairoil = {
  capacity: '1 fl oz',
  cat: 'shimmer_hairoil',
  description:
    'In this special edition Hair Oil, gold and bronze powders sourced from recycled jewelry join your custom blend of oils to add shine and sparkle.',
  isNew: false,
  label: 'Shimmer Hair Oil',
  picture: shoPicture,
  bgPicture: shoBgPicture,
  bgLabelledPicture: shoBgLabelledPicture,
  price: 48,
  productPageUrl: '/products/custom-shimmer-hair-oil',
  slug: productsSlugs.SHIMMER_HAIR_OIL,
  tag: 'Limited edition',
  cardTag: 'Limited edition',
  type: productsCategories.FORMULA,
  usageB: 'As needed',
};

export const supplement_core = {
  // capacity: '2 bottles, 30 capsules each - 30-day supply',
  capacity: 'One month supply',
  cat: 'core',
  description: (
    <>
      Your custom <b>Root Source</b>™ supplements provide natural and powerful ingredients known to
      soothe the scalp and to stimulate hair growth*.
    </>
  ),
  isNew: true,
  label: 'Root Source™ Hair Supplements',
  shortLabel: 'Root Source™',
  useShortLabel: true,
  displayLabel: (
    <>
      Root Source<sup css={{ fontFamily: 'Simplon Norm', fontSize: 18 }}>™</sup>
    </>
  ),
  labelDetail: (
    <>
      Root Source™ Hair Supplements
      <br />2 bottles, one month supply each
      <br /> Two capsules per day
    </>
  ),
  pluralLabel: 'Root Source™ Hair Supplements',
  picture: supplementsPicture,
  pictureWithCap: supplementsPicture,
  bgPicture: supplementsBgPicture,
  bgLabelledPicture: supplementsBgLabelledPicture,
  price: 52,
  productPageUrl: '/products/custom-hair-supplements',
  slug: productsSlugs.SUPPLEMENT_CORE,
  cardTag: 'New',
  tag: 'custom hair supplements',
  type: productsCategories.FORMULA,
};

export const supplements_pouch = {
  picture: supplementsPouchPicture,
  label: 'Root Source™ Hair Supplements',
  pluralLabel: 'Root Source™ Hair Supplements',
  labelDetail: (
    <>
      Root Source™ Hair Supplements
      <br />2 refill pouches, 30 capsules each, 30 day supply
      <br /> Two capsules per day
    </>
  ),
};

export const styling_gel = {
  capacity: '8.5 fl oz',
  cat: 'styling_gel',
  description:
    'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Laborum similique eum eius rem consequuntur enim, commodi quaerat adipisci iure rerum.',
  isNew: true,
  label: 'Styling Gel',
  picture: 'https://via.placeholder.com/1000x1015',
  bgPicture: 'https://via.placeholder.com/1125x1275',
  bgLabelledPicture: 'https://via.placeholder.com/1125x1275',
  price: 30,
  productPageUrl: '/products/styling-gel',
  slug: productsSlugs.STYLING_GEL,
  tag: 'Limited edition',
  cardTag: 'New',
  type: productsCategories.FORMULA,
  usageB: 'As needed',
};
